export default class horizontalResizer {
    constructor() {
        return {
            restrict: 'A',
            scope: {},
            controller: ResizerCtrl,
            controllerAs: 'resizer'
        }
    }
}

class ResizerCtrl {
    constructor($scope, $element, $window, $document) {
        this._element = $element;
        this._document = $document;
        this._window = $window;
        this._scope = $scope;

        this.innerResizer = $('.inner-resizer');
        this.minWidth = 400;
        this.wrapperWidth = parseInt($('.wrapper').css('width'));
        this.maxWidth = this.wrapperWidth - 50;
        this.contentTables = [];
        this.dragActive = false;

        this._scope.$on('browser:resizer:insert', (event, contentTables) => {
            this.contentTables = contentTables;
            $(this.innerResizer).css('width', $(this.contentTables[0]).css('width'));

            var l = (parseInt($('.wrapper').css('width')) - parseInt($(this.contentTables[0]).css('width')))/2 + 'px';
            $(this.innerResizer).css('left', l);
        });

        this._element.on('mousedown', (event) => {
            this.dragActive = true;
            event.preventDefault();

            this.startX = event.pageX;
            this.startW = parseInt($(this.contentTables[0]).css('width'));
            this.which = event.pageX > (this._window.outerWidth/2) ? 'right' : 'left';
            this._document.on('mousemove', );
            this._document.on('mouseup', this.mouseup)
        });

        this._element.on('mousemove', (event) => {
            if (this.dragActive) {
                this.mousemove(event);
            }
        });

        this._element.on('mouseup', () => {
            this.dragActive = false;
        });
    }

    mousemove(event) {
        let x = event.pageX;
        let widthDiff = this.which == 'left' ? (this.startX - x) * 2 : (x - this.startX) * 2;
        var newWidth = parseInt(this.startW) + parseInt(widthDiff);

        if (newWidth >=  this.maxWidth || newWidth <= this.minWidth) {
            return;
        }

        $(this.contentTables).css({
            width: newWidth + 'px',
            left: ((window.outerWidth - newWidth) / 2) + 'px'
        });

        $(this.innerResizer).css({
            width: newWidth + 'px',
            left: ((this.wrapperWidth - newWidth) / 2) + 'px'
        })
    }
}

/*angular.module('InBrowserApp').directive('horizontalResizer', function($document) {

    return function($scope, $element, $attrs) {
        $scope.innerResizer = $('.inner-resizer')
        var startX
        var startW
        var which
        var MIN_WIDTH = 400
        var WRAPPER_WIDTH = parseInt($('.wrapper').css('width'))
        var MAX_WIDTH = WRAPPER_WIDTH - 50

        $element.on('mousedown', function(event) {
            event.preventDefault()
            startX = event.pageX
            startW = parseInt($($scope.contentTables[0]).css('width'))
            which = event.pageX > (window.outerWidth/2) ? 'right' : 'left'
            $document.on('mousemove', mousemove)
            $document.on('mouseup', mouseup)
        })

        function mousemove(event) {
            var x = event.pageX
            var widthDiff = which == 'left' ? (startX - x)*2 : (x - startX)*2
            var newWidth = parseInt(startW) + parseInt(widthDiff)
            if (newWidth >=  MAX_WIDTH|| newWidth <= MIN_WIDTH) {
                return
            }
            $($scope.contentTables).css({
                width: newWidth + 'px',
                left: ((window.outerWidth - newWidth) / 2) + 'px'
            })
            $($scope.innerResizer).css({
                width: newWidth + 'px',
                left: ((WRAPPER_WIDTH - newWidth) / 2) + 'px'
            })
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove)
            $document.unbind('mouseup', mouseup)
        }
    }
})*/